import { z } from 'zod';

const MIN_AMOUNT = 1;
const MAX_AMOUNT = 999_999;
export const AMOUNT_SCHEMA = z.object({
  amount: z
    .number()
    .int('Amount must be an integer.')
    .min(MIN_AMOUNT)
    .max(MAX_AMOUNT),
});

export const EMAIL_SCHEMA = z.string().email('Invalid email.');